import template from './racedayEditPage.html';
import controller from './racedayEditPage.controller';
import './racedayEditPage.scss';

let racedayEditPageComponent = {
  restrict: 'E',
  bindings: {
    raceday: '='
  },
  template,
  controller
};

export default racedayEditPageComponent;
